import React from 'react';
import { ServerIcon, CloudIcon } from 'lucide-react';
import type { Processing } from '../../types/anna';
export function ProcessingTag({
  where,
  size = 'sm'
}: {
  where: Processing;
  size?: 'sm' | 'wall';
}) {
  const Icon = where === 'lokaal' ? ServerIcon : CloudIcon;
  const sizeClass = size === 'wall' ? 'gap-2 px-3 py-1 text-[22px]' : 'gap-1.5 px-2 py-1 text-[12px]';
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full bg-white/[0.05] font-medium text-ink-muted ${sizeClass}`} title={where === 'lokaal' ? 'Verwerkt op je eigen server' : 'Verwerkt in de cloud'} data-id="element-1366" data-mp="2kzs1ptyq9d99">
      <Icon className={size === 'wall' ? 'h-5 w-5' : 'h-3.5 w-3.5'} strokeWidth={1.75} aria-hidden data-id="element-1367" data-mp="2b8xd4iy0e1kn" />
      {where}
    </span>;
}